import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { generateViewsComponent } from "../../../../../../helpers/views.js";
import { useInput } from "../../../../../../hooks/forms/useInput/index.js";
import DesktopAccommodation from "./views/desktop/index.js";
import MobileAccommodation from "./views/mobile/index.js";
const AccommodationView = generateViewsComponent(DesktopAccommodation, MobileAccommodation);
export const Accommodation = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ _jsx(AccommodationView, {
        ...props,
        ref: ref
    }));
Accommodation.displayName = 'Accommodation';
export const FormAccommodation = (props)=>{
    const { isHiddenRequired: _isHiddenRequired , ...rest } = props;
    const { field , label  } = useInput(props);
    return /*#__PURE__*/ _jsx(Accommodation, {
        ...rest,
        ...field,
        label: label
    });
};
export default Accommodation;

//# sourceMappingURL=index.js.map